import React from 'react';
import { Badge, Tooltip } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';

interface CoinProps {
  className?: string;
  style?: React.CSSProperties;
}

export const Coin: React.FC<CoinProps> = ({ className, style }) => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};

  const handleClick = () => {
    // 可以在这里添加点击事件，比如跳转到积分详情页面
    console.log('点击积分图标');
  };

  return (
    <span
      className={className}
      style={{
        fontSize: '14px',
        color: '#666',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        ...style,
      }}
      onClick={handleClick}
    >
      商家余额：<span style={{ color: '#faad14' }}>{(currentUser as any)?.points || 0}</span>
    </span>
  );
};